import { render, staticRenderFns } from "./map_n_sms_config.vue?vue&type=template&id=9d60ffd8&"
import script from "./map_n_sms_config.vue?vue&type=script&lang=js&"
export * from "./map_n_sms_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports